import { OrganizationService } from "../../services";
import { useCRUDHandlers, useGridActions, useSharedState, useUrlParams } from "../../hooks";
import { TitlelessCard, ODataGrid, ResponsiveGridColumn } from "../../components";
import { OrganizationModel } from "../../data/entities";
import { routes } from "../../app/routes";
import { createODataQueryFilter } from "../../utils";

export function HostTenantOrganizationPage() {
  const gridData = useSharedState<Array<OrganizationModel>>([]);
  const organizationService = new OrganizationService();
  const id = parseInt(useUrlParams("id"));
  const { onClick, onSelect, showAddState} = useGridActions<OrganizationModel>(routes.host.tenant.organization);
  const { gridRef, getItems } = useCRUDHandlers<OrganizationModel>(organizationService, "Organization", showAddState);

  return (
      <TitlelessCard bodyClassName="p-0">
            <ODataGrid
              ref={gridRef}
              getData={(ODataQuery) => {
                const filterQuery = createODataQueryFilter(ODataQuery, [`TenantId eq ${id}`]);
                return getItems(filterQuery);
              }}
              dataState={gridData}
              onRowMenuSelect={onSelect}
              sort={[{ field: "name", dir: "asc"}]}
              scrollable="scrollable"
              pageSize={10}
             >
              <ResponsiveGridColumn
                  title="Organization Name"
                  field="name"
                  sortable={true}
              />
            </ODataGrid>
        </TitlelessCard>
    );
}

export default HostTenantOrganizationPage;

